import store from '@/store'
import {getItem} from '@/utils/storege'
import {USER_INFO} from '@/constants'
// 2026-09-09：只允许当前客户在当前入口提交原身份表单，来源和转派字段独立保留。
export type OrderIdentity={customerId:number;orgId:number}
const changedMessage='登录账号或分店已变化，填写内容已保留，请重新打开下单页面后提交'
export function orderIdentityError(){
  const error=new Error(changedMessage) as Error & {code:string}
  error.code='ORDER_CONTEXT_CHANGED'
  return error
}
const positiveId=(value:any)=>Number.isSafeInteger(Number(value)) && Number(value)>0
export function readOrderIdentity(customer:any,entryOrg:any,token:any,saved:any):OrderIdentity{
  if(typeof saved==='string'){
    try{saved=JSON.parse(saved)}catch(_error){throw orderIdentityError()}
  }
  if(!token || !positiveId(customer?.id) || !positiveId(customer?.orgId)
    || Number(entryOrg)!==Number(customer.orgId) || Number(saved?.id)!==Number(customer.id)
    || Number(saved?.orgId)!==Number(customer.orgId)) throw orderIdentityError()
  return Object.freeze({customerId:Number(customer.id),orgId:Number(customer.orgId)})
}
export function assertOrderIdentity(expected:OrderIdentity,actual:OrderIdentity){
  if(expected.customerId!==actual.customerId || expected.orgId!==actual.orgId) throw orderIdentityError()
}
export function prepareOrderSubmission(order:any,identity:OrderIdentity){
  if(!order || Number(order.customerId)!==identity.customerId || Number(order.orgId)!==identity.orgId
    || !Array.isArray(order.details) || !order.details.length
    || order.details.some((detail:any)=>!detail || typeof detail!=='object')) throw orderIdentityError()
  // 2026-09-09：销售明细仅在可信主单身份通过后规范副本；不更改原表单、商品来源或设计师转派。
  return {...order,customerId:identity.customerId,orgId:identity.orgId,
    details:order.details.map((detail:any)=>({...detail,orgId:identity.orgId}))}
}
export function captureOrderIdentity():OrderIdentity{
  return readOrderIdentity(store.getters.userInfo,store.getters.orgId,store.getters.token,getItem(USER_INFO))
}
